'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {
  403: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
    title: '403',
    desc: 'Та энэ хуудсанд хандах эрхгүй байна'
  },
  404: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
    title: '404',
    desc: 'Таны хайсан хуудас олдсонгүй'
  },
  500: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
    title: '500',
    desc: 'Хѳгжүүлэлт хийгдэж байна'
  }
};

exports.default = config;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Exception/typeConfig.js
// module id = 770
// module chunks = 0